import React from 'react';
import { useField } from 'formik';
import styled from 'styled-components/macro';
import { TextInputField } from '../../../../../shared/form/inputs/TextInputField';

type InputFieldProps = {
  name: string;
  referenceFieldName: string;
  label: string | React.ReactNode;
  onChange?: (newValue: string) => void;
  defaultValue?: string;
};

export const RoomsHeatLossInputField = (props: InputFieldProps) => {
  const [field] = useField(props.referenceFieldName);

  if (field.value !== '' && Number(field.value) === 0) {
    return <ShadedFormField name={props.name} label={props.label} onChange={props.onChange} disabled={true} />;
  }

  return <TextInputField name={props.name} label={props.label} onChange={props.onChange} />;
};

const ShadedFormField = styled(TextInputField)`
  background-color: dimgray;
`;
